import { Directive, ElementRef, inject, OnInit, input } from '@angular/core';
@Directive({ selector: '[miqIndent]' })
export class IndentDirective implements OnInit {
  private readonly el = inject(ElementRef);
  readonly miqIndent = input<number>(undefined);
  ngOnInit() {
    const miqIndent = this.miqIndent();
    if (miqIndent && this.el) {
      this.el.nativeElement.style.marginLeft = `${miqIndent * 38}px`;
    }
  }
}
